import React, { memo } from 'react';
import styles from './TableHead.module.scss';

interface MilestoneHeaderCellProps {
  label: string;
  approvalRequired?: boolean;
  async?: boolean;
  className?: string;
  labelClassName?: string;
  labelBoxClassName?: string;
}

const MilestoneHeaderCell: React.FC<MilestoneHeaderCellProps> = memo(
  ({
    label,
    approvalRequired,
    async: isAsync,
    className,
    labelClassName,
    labelBoxClassName
  }) => {
    // Use custom className if provided (e.g., betaHeaderContent), otherwise use default headerContent
    const headerClassName = className || styles.headerContent;
    const hasIcons = approvalRequired || isAsync;

    return (
      <div className={headerClassName}>
        <span className={labelBoxClassName || ''}>
          <span className={`${styles.headerLabel} ${labelClassName || ''}`}>
            {label}
          </span>
        </span>
        {hasIcons && (
          <div className={styles.headerIcons}>
            {approvalRequired && (
              <span className={styles.approvalIndicator}>A</span>
            )}
            {isAsync && (
              <img
                src="/icons/icon-email.svg"
                alt="Async"
                className={styles.emailIcon}
              />
            )}
          </div>
        )}
      </div>
    );
  }
);

MilestoneHeaderCell.displayName = 'MilestoneHeaderCell';

export default MilestoneHeaderCell;
